import { Platform } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Network } from '@ionic-native/network';

/*
  Generated class for the NetworkProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class NetworkMonitorProvider {

  private subscription: any = null;
  // private connectSubscription: any = null;
  // private disconnectSubscription: any = null;
  private callback: any = null;

  constructor(private platform: Platform, public network: Network) {
    console.log('Hello NetworkMonitorProvider Provider');
  }

  isAirplaneMode() {
    return (this.network.type === 'unknown') ||
      (this.network.type === 'none') ||
      (this.network.type === '') ||
      (this.network.type === null) ||
      (this.network.type === undefined);
  }

  isWifi() {
    return (this.network.type === 'wifi');
  }

  isOnline() {
    if (this.platform.is('cordova')) {
      return (this.network.type !== 'none');
    } else {
      return navigator.onLine;
    }
  }

  start() {
    // DONE: Fix error cordova_not_available
    if (this.platform.is('cordova')) {
      let that = this;

      this.subscription = this.network.onchange().subscribe(() => {
        setTimeout(() => {
          console.log('Online: ' + (that.isOnline() ? 'Y' : 'N'));
          console.log('Wifi: ' + (that.isWifi() ? 'Y' : 'N'));
          console.log('Airplane Mode: ' + (that.isAirplaneMode() ? 'Y' : 'N'));

          if (that.callback !== null) {
            that.callback(that.isOnline(), that.isWifi(), that.isAirplaneMode());
          }
        }, 1000);
      });
    } else {
      if (this.callback !== null) {
        this.callback(true, false);
      }
    }
  }

  stop() {
    if (this.subscription !== null) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }

    // if (this.connectSubscription !== null) {
    //   this.connectSubscription.unsubscribe();
    //   this.connectSubscription = null;
    // }

    // if (this.disconnectSubscription !== null) {
    //   this.disconnectSubscription.unsubscribe();
    //   this.disconnectSubscription = null;
    // }
  }

  setCallback(callback: any) {
    this.callback = callback;
  }

}



// WEBPACK FOOTER //
// ./src/providers/network-monitor/network-monitor.ts